import { useLDClient } from 'launchdarkly-react-client-sdk';

import { FeatureFlags } from './featureFlags.type';

// A flag reads as off until LaunchDarkly has a client. Nothing waits for it.
export const useFeatureFlags = (): FeatureFlags => {
  const client = useLDClient();

  return {
    isConnectedTurnaroundEnabled: client?.variation('enable-connected-turnaround', false) === true,
  };
};
